module.exports = __webpack_public_path__ + "static/media/money_bonus_3.d21e13cc.svg";